import { createSlice } from "@reduxjs/toolkit";
import {
  getAddresses,
  addAddress,
  updateAddress,
  deleteAddress,
} from "./thunk";

const initialState = {
  list: [], // all addresses
  loading: false,
  error: null,
  successMessage: null,
};

const addressesSlice = createSlice({
  name: "addresses",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // 🟦 GET ADDRESSES
      .addCase(getAddresses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAddresses.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.error = null;
      })
      .addCase(getAddresses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🟦 ADD ADDRESS
      .addCase(addAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(addAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload.data);
        state.successMessage = "Address added successfully";
      })
      .addCase(addAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🟦 UPDATE ADDRESS
      .addCase(updateAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = "Address updated successfully";

        const updated = action.payload.data;

        state.list = state.list.map((addr) =>
          addr.id === updated.id ? updated : addr
        );
      })

      // 🟦 DELETE ADDRESS
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.loading = false;
        const removedId = action.payload;
        state.list = state.list.filter((a) => a.id !== removedId);
        state.successMessage = "Address deleted successfully";
      });
  },
});

export default addressesSlice.reducer;
